<template>
  <div class="phy_wrap">
    <!-- 变异风险 -->
    <div class="organ_list">
      <div class="list_top">
        <div class="risks">
          <div
            :class="index == statusIndex ? 'riskActive' : ''"
            v-for="(item, index) in ristStatus"
            :key="index"
            @click="changeStatus(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="list_bottom">
        <div v-if="risklist.length != 0" class="risks">
          <div
            :class="activeOrgan.name == item.name ? 'orgActive' : ''"
            v-if="item.level - 1 == statusIndex && !item.notShow"
            v-for="(item, index) in risklist"
            :key="index"
            @click.stop="handleOrgan(item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div v-else class="noOrgan">该风险暂无器官</div>
      </div>
    </div>
    <div style="padding-bottom: 120px">
      <img
        class="wenhao"
        :src="ossUrl + '/wenhao.png'"
        data-type="risk"
        @click="showSigns"
      />
      <img class="man-middle-bg" :src="ossUrl + '/whitepointer.png'" />
      <img class="man-bottom-bg" :src="ossUrl + '/platform.png'" />
      <div class="person" :class="sex == 1 ? 'manperson' : 'womanperson'">
        <img
          v-if="sex == 1"
          class="man_bg"
          :src="ossUrl + '/qiguan/man_body.png'"
        />
        <img
          v-if="sex == 2"
          class="man_bg"
          :src="ossUrl + '/qiguan/woman_body.png'"
        />
        <template v-for="(item, index) in organlist">
          <img
            :key="index"
            v-if="item.imgurl !== ''"
            :class="item.imgurl"
            :src="item.avaturl"
            @click="handleRect(item)"
          />
          <div
            :key="index"
            v-else
            class="circles"
            @click="handleRect(item)"
          ></div>
        </template>
        <img class="diseasa-nose" :src="ossUrl + '/diseasa/nose.png'" />
      </div>
    </div>
    <div
        v-if="activeOrgan.experts_science"
        class="organ-text"
      >
        <div class="text-title">
          <span>常见健康风险</span>
        </div>
        <span class="text-txt">{{ activeOrgan.experts_science }}</span>
        <div class="text-title">
          <span>健康管理建议</span>
        </div>
        <span class="text-txt">{{ activeOrgan.exam_references }}</span>
      </div>
    <!-- 弹层 -->
    <div
      v-if="showOrganDialog"
      class="dialog"
      :class="activeOrgan.class"
      :style="{ top: activeOrgan.top, left: activeOrgan.left }"
    >
      <div class="rowLine">
        <img class="blueCircle" :src="ossUrl + '/organCircle.png'" />
      </div>
      <div class="colLine"></div>
      <div class="box">
        <div class="boxTop">{{ activeOrgan.name }}</div>
        <div class="status">
          <div v-if="activeOrgan.name != '脑血管风险'">
            <span>风险数值：</span
            >{{
              activeOrgan.name == "脑血管风险"
                ? activeOrgan.functional_status
                : activeOrgan.a
            }}
          </div>
          <div v-else><span>风险等级：</span>{{ activeOrgan.level }}</div>
        </div>
      </div>
    </div>
    <model-div title="名词解释及数值划分" :show-sign="showSign" @hide-signs="hideSigns">
       <span v-html="signText"></span>
    </model-div>
  </div>
</template>
<script>
import json from "@/utils/json";
const ossUrl = "http://img.xiaoqijiankang.com/images";
import ModelDiv from "@/components/ModelDiv"
export default {
  props: ["list"],
  components: { ModelDiv },
  data() {
    return {
      ossUrl,
      person: {},
      noHealth: true, //是否有检测数据
      activeIndex: 0, //当前显示 0 人体 ，1 脊椎
      ristStatus: [
        { name: "低", id: 1 },
        { name: "偏低", id: 2 },
        { name: "中", id: 3 },
        { name: "偏高", id: 4 },
        { name: "高", id: 5 },
      ], // 免疫风险等级
      organlist: [], //人体器官
      risklist: [], //风险器官列表
      vertebralist: [], //脊椎列表
      sex: 2, //性别,
      statusIndex: 0,
      activeOrgan: {},
      marks: "", //当前报告分数，
      showOrganDialog: false,
      datalist: this.list,
      organlist: [],
      signText: '',
      showSign: false,
    };
  },
  watch: {
    list(newVal) {
      console.log("list的值改变啦啦啦啦啦啦啦");
      console.log("newVal", newVal);
      this.datalist = newVal;
      this.getReport();
    },
  },
  methods: {
    showSigns() {
      const riskTxt = `
      任何疾病的产生都始于早期功能紊乱，在疾病发生前，
      相关组织与器官的功能性变化往往会先于器质
      性病变而产生。在疾病发展过程中的排异期、积累
      期、潜伏期或功能异常期及早检测、分析出功能紊乱
      的程度，有助于对疾病进行超早预防。<br>
        风险数值划分：<br>
        0-20，低<br>
        21-40，偏低<br>
        41-60，中<br>
        61-80，偏高<br>
        80-100，高<br>
        持续的风险过高，说明健康改变的程度、
        潜在的疾病风险较高，应该有针对性的进行预防调理，必要
        时进行进一步诊断检查。`;
      this.signText = riskTxt;
      this.showSign = true;
    },
    hideSigns() {
      this.showSign = false
    },
    showDialog() {
      this.$emit("show-dialog");
    },
    /**切换弹层器官展示 */
    handleOrgan(item) {
      let list = this.sex == 1 ? `risk_man_arr` : `risk_woman_arr`;
      let activeOrgan = {};
      json[list].forEach((ele) => {
        if (item.imgurl == ele.icon) {
          item.top = ele.top;
          item.left = ele.left;
          activeOrgan = item;
        }
      });
      this.activeOrgan = activeOrgan;
      console.log("this.activeOrgan", this.activeOrgan);
      this.recalc(activeOrgan.top, activeOrgan.left);
      this.showOrganDialog = true;
    },
    /**计算适配 */
    recalc(dialogtop, dialogleft) {
      var clientWidth = document.documentElement.clientWidth;
      var clientHeight = document.documentElement.clientHeight;
      let top;
      if (clientHeight >= 740) {
        if (dialogtop >= 500) {
          top = dialogtop * (clientHeight / 1500) + 60 + "px";
        } else {
          top = dialogtop * (clientHeight / 1500) + 55 + "px";
        }
      } else if (clientHeight <= 480) {
        top = dialogtop * (clientHeight / 1500) + 50 + "px";
      } else {
        top = dialogtop * (clientHeight / 1500) + 50 + "px";
      }
      let left = dialogleft * (clientWidth / 750) + "px";
      console.log("height", dialogtop, "width", dialogleft);
      this.activeOrgan.class =
        dialogleft < clientWidth / 2 ? "leftDialog" : "rightDialog";
      this.activeOrgan.left = left;
      this.activeOrgan.top = top;
    },
    changeStatus(item) {
      this.handleOrganlist(item.id);
      this.statusIndex = item.id - 1;
      this.showOrganDialog = false;
    },
    /**器官脊椎tab切换 */
    handleOrganlist(id) {
      let risklist = [];
      let list = this.activeIndex == 0 ? "organlist" : "vertebralist";
      this.organlist.forEach((e) => {
        if (e.level === id) {
          risklist.push(e);
        }
        this.risklist = risklist;
      });
    },
    /**获取报告详情 */
    getReport() {
      const organlist = this.datalist.organs;
      organlist.forEach((e) => {
        e.imgstatus = e.level == 1 ? 1 : e.level <= 3 ? 2 : 3;
        if (e.name == "左肺") {
          e.imgurl = "lung_left";
        } else if (e.name == "右肺") {
          e.imgurl = "lung_right";
        } else if (e.name == "左侧大脑") {
          e.imgurl = "brain_left";
        } else if (e.name == "右侧大脑") {
          e.imgurl = "brain_right";
        } else if (e.name == "左乳腺") {
          e.imgurl = "breast_left";
        } else if (e.name == "右乳腺") {
          e.imgurl = "breast_right";
        } else {
          e.imgurl = e.icon;
        }
        e.avaturl = `${ossUrl}/qiguan/${e.imgurl}${e.imgstatus}.png`;
      });
      this.organlist = organlist;
      this.noHealth = false;
      this.handleOrganlist(0);
    },
    /**初始化器官/脊椎 */
    changeTapData(number) {
      (this.activeIndex = number), (this.showOrganDialog = false);
      this.handleOrganlist(0);
    },
  },
  created() {
    console.log("asd", this.list);
    this.sex = this.datalist.sex;
    this.marks = this.datalist.marks;
    this.getReport();
  },
};
</script>
<style lang="scss" scoped>
.phy_wrap {
  width: 100%;
  height: 100%;
  margin: auto;
  overflow: auto;
}
.organ_list {
  position: relative;
  z-index: 5;
  margin: 10px auto;
  padding-bottom: 0;
  background-color: #fff;
}
.list_top {
  background-color: transparent;
  padding: 5px;
  box-shadow: none;
}
.list_bottom {
  background-color: transparent;
  padding: 10px 0 20px;
}
.list_bottom .diseasa-risks div {
  width: 209px;
  margin-left: 10px;
}
/* .list_bottom .diseasa-risks div:nth-child(3n+1) {
  margin-left: 0;
} */
.list_bottom .diseasa-risks div:nth-child(4n + 1) {
  margin-left: 10px;
}
.person {
  top: 0;
}
.middle-mark {
  position: relative;
  width: 340px;
  height: 340px;
  margin: 40px auto;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  font-size: 50px;
  color: #929292;
  border-radius: 50%;
}
.middle-mark > div {
  margin-top: 30px;
}
.middle-mark > .marksTxt {
  position: absolute;
  top: 30px;
  left: 0;
  text-align: center;
  font-weight: 600;
  width: 100%;
  font-size: 120px;
  height: 140px;
  color: #1681e1;
}
.circletxt {
  position: absolute;
  top: 190px;
  left: 0;
  text-align: center;
  width: 100%;
  height: 40px;
}
.cicle .bar {
  position: absolute;
  width: 325px;
  height: 325px;
  left: 0;
  right: 0;
  /* overflow: hidden; */
  z-index: 5;
}
.cicle .bar-left {
  top: 15px;
  left: 15px;
}
.cicle .bar-left .bar-left-an {
  position: absolute;
  z-index: 10;
  width: 292px;
  height: 292px;
  border-width: 10px;
  border-color: transparent transparent #5fc5e0 #5fc5e0;
  border-style: solid;
  border-radius: 50%;
  transform: rotate(-135deg);
}
.cicle .bar-right {
  top: -1px;
  left: -101px;
}
.cicle .bar-right .bar-right-an {
  position: absolute;
  top: 17px;
  left: 116px;
  z-index: 20;
  width: 292px;
  height: 292px;
  border-width: 10px;
  border-color: #5fc5e0 #5fc5e0 transparent transparent;
  border-style: solid;
  border-radius: 50%;
  transform: rotate(-135deg);
}
.dialog .box .status {
  display: flex;
  align-items: center;
  height: 102px;
  flex-wrap: wrap;
}
.dialog .box .status > div {
  width: 100%;
}
.dialog .box .status > div:first-child {
  margin-top: 0;
}
/* news */
/* 背景白点 */
.man-middle-bg {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
}
.man-bottom-bg {
  position: absolute;
  top: 1450px;
  left: 0;
  width: 100%;
}
.totallist {
  width: 700px;
  margin: auto;
}
.special {
  background-color: #fff;
  padding: 0 25px;
  margin: 0 auto 20px;
}
.risk_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  padding: 30px 0;
  font-size: 34px;
}
.risk_top > div:first-child {
  display: flex;
  align-items: center;
}
.risk_top image {
  width: 42px;
  height: 42px;
  vertical-align: middle;
  margin-right: 16px;
}
.statuslist {
  display: flex;
}
.statuslist .ristStatus {
  width: 68px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  background-color: #b5b5b5;
  border-left: 1px solid #fff;
  font-size: 24px;
  text-align: center;
}
.statuslist .active {
  position: relative;
}
.statuslist .active::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  bottom: -20px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom-width: 20px;
  border-bottom-style: solid;
}
.ristStatus:nth-child(1) {
  background-color: #009944;
}
.ristStatus:nth-child(1).active::before {
  border-bottom-color: #009944;
}
.ristStatus:nth-child(2) {
  background-color: #feae63;
}
.ristStatus:nth-child(2).active::before {
  border-bottom-color: #feae63;
}
.ristStatus:nth-child(3) {
  background-color: #f29238;
}
.ristStatus:nth-child(3).active::before {
  border-bottom-color: #f29238;
}
.ristStatus:nth-child(4) {
  background-color: #dd352a;
}
.ristStatus:nth-child(4).active::before {
  border-bottom-color: #dd352a;
}
.ristStatus:nth-child(5) {
  background-color: #a01d18;
}
.ristStatus:nth-child(5).active::before {
  border-bottom-color: #a01d18;
}
.risk_cont {
  font-size: 28px;
  color: #616161;
  padding: 25px 0;
  border-bottom: 1px solid #ddd;
  text-align: left;
}
.red_title {
  font-size: 28px;
  color: #d30909;
  margin: 25px 0 5px;
  font-weight: bold;
}
.risk_btn {
  font-size: 24px;
  color: #949494;
  padding: 25px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.risk_btn image {
  width: 21px;
  height: 11px;
  margin-left: 5px;
}
.risk_btn image.rotates {
  transform: rotate(180deg);
}
.nodata {
  position: relative;
  width: 640px;
  margin: auto;
  text-align: left;
  padding: 60px 0;
  line-height: 50px;
}
.nodata p {
  margin-bottom: 20px;
  margin-top: 0;
}
/* 慢性病风险 */
.organ-text {
  position: relative;
  background-color: #fff;
  padding: 30px 20px;
  margin-top: -60px;
}
.text-title {
  position: relative;
  font-size: 30px;
  margin: 0 0 30px;
  color: #616161;
  height: 32px;
}
.text-title span {
  position: absolute;
  left: 0;
  z-index: 2;
  height: 32px;
}
.text-title::before {
  content: "";
  position: absolute;
  top: 20px;
  left: -8px;
  background-color: rgba(46, 148, 229, 0.4);
  width: 70px;
  height: 25px;
  border-radius: 10px 0 10px 0;
  display: block;
}
.text-txt {
  font-size: 28px;
  margin-bottom: 30px;
  color: #616161;
  line-height: 48px;
  display: block;
}
.diseasa-nose {
  position: absolute;
  left: 170px;
}
.manperson .diseasa-nose {
  top: 65px;
  width: 12px;
}
.womanperson .diseasa-nose {
  top: 54px;
  width: 10px;
}
.ovary {
  position: absolute;
  top: 400px;
  left: 130px;
  width: 100px;
}
.wenhao {
  position: absolute;
  top: 425px;
  left: 40px;
  width: 50px;
  height: 50px;
  z-index: 5;
}
.list_top {
  padding: 5px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 4px 0 rgba(7, 0, 2, 0.3);
}
.list_top > div:first-child {
  display: flex;
  align-items: center;
  height: 60px;
  margin-bottom: 10px;
}
.list_top image {
  width: 45px;
  height: 45px;
  margin-left: 15px;
}
.risks {
  width: 680px;
  margin: 25px auto;
  display: flex;
  justify-content: space-between;
}
.risks div {
  position: relative;
  width: 130px;
  height: 60px;
  color: #fff;
  /* background-color: #AAA; */
  text-align: center;
  line-height: 60px;
  border-radius: 30px;
  font-size: 32px;
}
.risks > div::before {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 5%;
  width: 90%;
  height: 4px;
  border-radius: 4px;
}
.list_middle {
  position: relative;
  margin: -8px auto 0;
  width: 687px;
  height: 58px;
  display: block;
}
.list_bottom {
  margin-top: -14px;
  height: auto;
  background-color: #fff;
  padding: 30px 0;
}
.list_bottom .risks {
  width: 680px;
  margin: 20px auto 0;
  display: flex;
  height: 150px;
  justify-content: start;
  flex-wrap: wrap;
  overflow-y: auto;
}
.risks div::before {
  content: "";
  position: absolute;
  bottom: -16px;
  left: 5%;
  width: 90%;
  height: 6px;
  border-radius: 6px;
}
.risks > div:first-child.riskActive::before {
  background: linear-gradient(to right, #6ef086, #30d24e);
}
// .risks>div:nth-child(2).riskActive{
//   background: linear-gradient(to right,#A2E317,#6EF086);
// }
.risks > div:nth-child(2).riskActive::before {
  background: linear-gradient(to right, #feae63, #feae63);
}
// .risks>div:nth-child(3).riskActive{
//   background: linear-gradient(to right,#EBA059,#FF891C);
// }
.risks > div:nth-child(3).riskActive::before {
  background: linear-gradient(to right, #eba059, #ff891c);
}
// .risks>div:nth-child(4).riskActive{
//   background: linear-gradient(to right,#FF7C7C,#EE5151);
// }
.risks > div:nth-child(4).riskActive::before {
  background: linear-gradient(to right, #ff7c7c, #ee5151);
}
// .risks>div:nth-child(5).riskActive{
//   background: linear-gradient(to right,#EF5454,#E82C2C);
// }
.risks > div:nth-child(5).riskActive::before {
  background: linear-gradient(to right, #ef5454, #e82c2c);
}
.list_top .risks > div:first-child {
  background: linear-gradient(to right, #6ef086, #30d24e);
}
.list_top .risks > div:nth-child(2) {
  background: linear-gradient(to right, #feae63, #feae63);
}
.list_top .risks > div:nth-child(3) {
  background: linear-gradient(to right, #eba059, #ff891c);
}
.list_top .risks > div:nth-child(4) {
  background: linear-gradient(to right, #ff7c7c, #ee5151);
}
.list_top .risks > div:nth-child(5) {
  background: linear-gradient(to right, #ef5454, #e82c2c);
}
.list_bottom .risks div {
  background-color: #fff;
  color: #1681e1;
  font-size: 26px;
  width: 162px;
  border: 1px solid #1681e1;
  margin-bottom: 16px;
  margin-left: 10px;
  width: 157px;
}
.list_bottom .risks div.orgActive {
  color: #fff;
  border: 1px solid #fff;
  background-color: #1681e1;
}
.list_bottom .risks div:nth-child(4n + 1) {
  margin-left: 0;
}
.noOrgan {
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  color: #999;
}

/* 背景白点 */
.man-middle-bg {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
}
.man-bottom-bg {
  position: absolute;
  top: 1220px;
  left: 0;
  width: 100%;
  margin-bottom: -60px;
}
.totallist {
  width: 700px;
  margin: auto;
}
.special {
  background-color: #fff;
  padding: 0 25px;
  margin: 0 auto 20px;
}

.person {
  position: relative;
  width: 350px;
  height: auto;
  max-height: 877px;
  overflow: hidden;
  margin: auto;
  top: 60px;
  animation: shows linear 0.35s;
  animation-fill-mode: forwards;
}
.person .man_bg {
  width: 100%;
}
.person .brain_left {
  position: absolute;
  right: 148px;
  top: 8px;
  width: 23px;
}
.person .brain_right {
  position: absolute;
  left: 150px;
  top: 8px;
  width: 23px;
}
.person .lung_left {
  position: absolute;
  right: 109px;
  top: 139px;
  width: 63px;
}
.person .lung_right {
  position: absolute;
  left: 107px;
  top: 139px;
  width: 63px;
}
.person .liver {
  position: absolute;
  left: 114px;
  top: 234px;
  width: 80px;
}
.person .kidney_left {
  position: absolute;
  right: 131px;
  top: 256px;
  width: 41px;
  z-index: 1;
}
.person .kidney_right {
  position: absolute;
  left: 133px;
  top: 256px;
  width: 41px;
}
.person .pancreas {
  position: absolute;
  left: 172px;
  top: 280px;
  width: 40px;
}
.person .heart {
  position: absolute;
  left: 175px;
  top: 170px;
  width: 51px;
}
.manperson .nose {
  position: absolute;
  top: 61px;
  left: 169px;
  width: 15px;
}
.person .trachea {
  position: absolute;
  left: 168px;
  top: 113px;
  width: 14px;
}
.person .trachea_q {
  position: absolute;
  left: 168px;
  top: 113px;
  width: 12px;
}
.person .trachea_z {
  position: absolute;
  left: 162px;
  top: 159px;
  width: 28px;
  z-index: 1;
}
.person .gullet {
  position: absolute;
  width: 36px;
  left: 163px;
  top: 112px;
}
.person .stomach {
  position: absolute;
  left: 150px;
  top: 220px;
  width: 86px;
}
.person .intestine_12 {
  position: absolute;
  left: 158px;
  top: 275px;
  width: 40px;
}
.person .intestine_da {
  position: absolute;
  left: 114px;
  top: 280px;
  width: 119px;
}
.person .intestine_xiao {
  position: absolute;
  left: 126px;
  top: 304px;
  width: 99px;
}
.person .spleen {
  position: absolute;
  left: 213px;
  top: 226px;
  width: 33px;
}
.person .thyroid {
  position: absolute;
  left: 161px;
  top: 124px;
  width: 26px;
}
.person .gallbladder {
  position: absolute;
  left: 118px;
  top: 269px;
  width: 22px;
}
.person .bladder {
  position: absolute;
  left: 159px;
  top: 412px;
  width: 36px;
}
.person .andrology {
  position: absolute;
  left: 154px;
  top: 418px;
  width: 44px;
}
.person .andrology_q {
  position: absolute;
  left: 154px;
  top: 418px;
  width: 44px;
}
.person .andrology_left {
  position: absolute;
  right: 147px;
  top: 401px;
  width: 20px;
}
.person .andrology_right {
  position: absolute;
  left: 148px;
  top: 401px;
  width: 20px;
}
.person .breast_left {
  position: absolute;
  right: 119px;
  top: 205px;
  width: 20px;
}
.person .breast_right {
  position: absolute;
  left: 119px;
  top: 205px;
  width: 20px;
}
/* 20212.2新加器官 */
.blood {
  position: absolute;
  left: 37px;
  top: 112px;
  width: 278px;
}
.lumbosacral_left {
  position: absolute;
  left: 221px;
  top: 260px;
  width: 20px;
}
.lumbosacral_right {
  position: absolute;
  left: 108px;
  top: 260px;
  width: 20px;
}
.manperson .upper_left {
  position: absolute;
  right: 23px;
  top: 176px;
  width: 88px;
}
.manperson .upper_right {
  position: absolute;
  left: 23px;
  top: 176px;
  width: 88px;
}
.person .shoulder_left {
  position: absolute;
  right: 66px;
  top: 147px;
  width: 49px;
}
.person .shoulder_right {
  position: absolute;
  left: 66px;
  top: 147px;
  width: 49px;
}
.person .hip_left {
  position: absolute;
  right: 101px;
  top: 381px;
  width: 32px;
}
.person .hip_right {
  position: absolute;
  left: 101px;
  top: 381px;
  width: 32px;
}
.manperson .the_da_left {
  position: absolute;
  right: 84px;
  top: 450px;
  width: 96px;
}
.manperson .the_da_right {
  position: absolute;
  left: 84px;
  top: 450px;
  width: 96px;
}
.person .knee_left {
  position: absolute;
  right: 114px;
  top: 615px;
  width: 50px;
}
.person .knee_right {
  position: absolute;
  left: 114px;
  top: 615px;
  width: 50px;
}
.manperson .the_xiao_left {
  position: absolute;
  right: 104px;
  top: 665px;
  width: 70px;
}
.manperson .the_xiao_right {
  position: absolute;
  left: 104px;
  top: 665px;
  width: 70px;
}
/* 女生样式 */
.womanperson .brain_left {
  position: absolute;
  right: 152px;
  top: 10px;
  width: 23px;
}
.womanperson .brain_right {
  position: absolute;
  left: 152px;
  top: 10px;
  width: 23px;
}
.womanperson .nose {
  position: absolute;
  top: 58px;
  left: 169px;
  width: 12px;
}
.womanperson .shoulder_left {
  position: absolute;
  right: 78px;
  top: 145px;
  width: 48px;
}
.womanperson .shoulder_right {
  position: absolute;
  left: 74px;
  top: 145px;
  width: 48px;
}
.womanperson .upper_left {
  position: absolute;
  right: 29px;
  top: 180px;
  width: 82px;
}
.womanperson .upper_right {
  position: absolute;
  left: 27px;
  top: 180px;
  width: 82px;
}
.womanperson .the_da_left {
  position: absolute;
  right: 94px;
  top: 455px;
  width: 84px;
}
.womanperson .the_da_right {
  position: absolute;
  left: 94px;
  top: 455px;
  width: 84px;
}
.womanperson .knee_left {
  position: absolute;
  right: 114px;
  top: 595px;
  width: 50px;
}
.womanperson .knee_right {
  position: absolute;
  left: 114px;
  top: 595px;
  width: 50px;
}
.womanperson .the_xiao_left {
  position: absolute;
  right: 110px;
  top: 647px;
  width: 65px;
}
.womanperson .the_xiao_right {
  position: absolute;
  left: 110px;
  top: 647px;
  width: 65px;
}
.womanperson .andrology_luan {
  position: absolute;
  left: 154px;
  top: 418px;
  width: 44px;
}
.uterus {
  position: absolute;
  left: 155px;
  top: 388px;
  width: 51px;
}
.person circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: transparent;
}
/* 器官状态弹层 */
.dialog {
  position: absolute;
  top: var(--top);
  left: var(--left);
  width: 360px;
  height: auto;
}
.dialog .rowLine {
  position: absolute;
  top: 0;
  width: 160px;
  border-top: 1px dashed #5fc5e0;
  animation: shows linear 0.35s;
  animation-delay: 0.25s;
  animation-fill-mode: forwards;
}
.dialog .rowLine .blueCircle {
  position: absolute;
  top: -12px;
  left: 0;
  width: 24px;
  height: 24px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  animation: shows linear 0.25s;
  animation-fill-mode: forwards;
}
.rightDialog .rowLine {
  left: -42px;
}
.rightDialog .rowLine .blueCircle {
  left: -12px;
}
.leftDialog .rowLine {
  left: 120px;
}
.leftDialog .rowLine .blueCircle {
  left: 164px;
}
.dialog .colLine {
  position: absolute;
  top: 0;
  left: 121px;
  height: 44px;
  border-left: 1px dashed #5fc5e0;
  animation: shows linear 0.25s;
  animation-delay: 0.6s;
  animation-fill-mode: forwards;
}
.dialog .box {
  position: absolute;
  top: 44px;
  left: 0;
  width: 245px;
  height: 160px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  animation: shows linear 0.5s;
  animation-delay: 0.8s;
  animation-fill-mode: forwards;
  background-image: url("../assets/image/dialog.png");
  padding: 0;
}
.dialog .box .boxTop {
  width: 100%;
  height: 50px;
  background-color: #60c5ff;
  line-height: 50px;
  color: #0466bd;
  font-size: 28px;
  text-align: center;
  margin: auto;
  font-weight: bold;
}
.dialog .box .status {
  padding: 0 18px;
}
.dialog .box .status div {
  color: #808080;
  font-size: 24px;
  margin-top: 12px;
}
.dialog .box .status div span {
  color: #1681e1;
  font-size: 24px;
}
</style>